import { render, staticRenderFns } from "./NotificationNotipayListComponent.vue?vue&type=template&id=2e23349a"
import script from "./NotificationNotipayListComponent.vue?vue&type=script&lang=js"
export * from "./NotificationNotipayListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports